import React, { useRef } from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { toPng } from 'html-to-image';

const CaptureBarChart = () => {
    const chartRef = useRef(null);

    const handleCapture = () => {
        if (chartRef.current) {
            toPng(chartRef.current)
                .then((dataUrl) => {
                    // Aquí puedes guardar la imagen o descargarla
                    const link = document.createElement('a');
                    link.download = 'bar-chart.png';
                    link.href = dataUrl;
                    link.click();
                })
                .catch((err) => {
                    console.error('Error al capturar la imagen:', err);
                });
        }
    };

    return (
        <div>
            <div ref={chartRef} style={{ height: 400, width: 600 }}>
                <ResponsiveBar
                    data={[
                        { country: 'AD', 'hot dog': 60, 'hot dogColor': 'hsl(206, 70%, 50%)' },
                        { country: 'AE', 'hot dog': 50, 'hot dogColor': 'hsl(55, 70%, 50%)' },
                        { country: 'AF', 'hot dog': 80, 'hot dogColor': 'hsl(27, 70%, 50%)' },
                        { country: 'AG', 'hot dog': 90, 'hot dogColor': 'hsl(204, 70%, 50%)' },
                    ]}
                    keys={['hot dog']}
                    indexBy="country"
                    margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                    padding={0.3}
                    layout="horizontal"
                    colors={{ scheme: 'nivo' }}
                    borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'country',
                        legendPosition: 'middle',
                        legendOffset: 32,
                    }}
                    axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'hot dog',
                        legendPosition: 'middle',
                        legendOffset: -40,
                    }}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                    legends={[
                        {
                            dataFrom: 'keys',
                            anchor: 'bottom-right',
                            direction: 'column',
                            justify: false,
                            translateX: 120,
                            translateY: 0,
                            itemsSpacing: 2,
                            itemWidth: 100,
                            itemHeight: 20,
                            itemDirection: 'left-to-right',
                            itemOpacity: 0.85,
                            symbolSize: 20,
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemOpacity: 1,
                                    },
                                },
                            ],
                        },
                    ]}
                    animate={true}
                    motionStiffness={90}
                    motionDamping={15}
                />
            </div>
            <button onClick={handleCapture}>Capturar Gráfico</button>
        </div>
    );
};

export default CaptureBarChart;
